import type { WeddingContextSummary } from '../wedding-context-summary';

// The parts of the planning summary that say what the couple already did.
export type CoupleActivity = Pick<WeddingContextSummary, 'profile' | 'suppliers' | 'budget'>;

/**
 * Whether the couple already planned something: a supplier saved, enquired or booked, a task
 * done, a budget set up, or guests on the list. The empty chat, the opener and onboarding all
 * use this one rule. A budget figure alone does not count, only a set-up budget.
 */
export const isExistingCouple = (ctx: CoupleActivity | undefined): boolean => {
  const profile = ctx?.profile;
  if (!profile) return false;
  return (
    profile.venueBooked ||
    (ctx.suppliers?.booked.length ?? 0) > 0 ||
    (ctx.suppliers?.shortlistedTotal ?? 0) > 0 ||
    profile.tasksDone > 0 ||
    profile.guestCount > 0 ||
    ctx.budget?.projected === false
  );
};
